// Native details owns menu state; close it after navigation or dismissal.
(() => {
  const menus = [...document.querySelectorAll('.daylight__menu')];
  document.addEventListener('click', (event) => {
    for (const menu of menus) {
      if (!menu.open) continue;
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    for (const menu of menus) {
      if (!menu.open) continue;
      menu.open = false;
      menu.querySelector('summary')?.focus();
    }
  });
})();
